module.exports = __webpack_public_path__ + "img/art.da8cda00.svg";